import axios, { getAuthHeader } from './client.ts';
import services from './services.ts';

export const ENDPOINTS = {
  LINK_X_ACCOUNT: (userId: string) => `${services.X_AUTH}/user/${userId}`,
};

export const getXAccountDetails = async (userId: string, token: string) =>
  axios.get(ENDPOINTS.LINK_X_ACCOUNT(userId), {
    headers: { ...{ 'Content-Type': 'application/json' }, ...getAuthHeader(token) },
  });

export const startLinkXAccount = async (userId: string, token: string) =>
  axios.post(
    ENDPOINTS.LINK_X_ACCOUNT(userId),
    {},
    {
      headers: { ...{ 'Content-Type': 'application/json' }, ...getAuthHeader(token) },
    },
  );

export const finishLinkXAccount = async (userId: string, data: { state: string; code: string }) =>
  axios.put(ENDPOINTS.LINK_X_ACCOUNT(userId), data, {
    headers: { 'Content-Type': 'application/json' },
  });

export const unlinkXAccount = async (userId: string, token: string) =>
  axios.delete(ENDPOINTS.LINK_X_ACCOUNT(userId), {
    headers: { ...{ 'Content-Type': 'application/json' }, ...getAuthHeader(token) },
  });
